import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { areasTitles } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { sendData } from "../../../services/sendData";
import { emptys } from "../../../data/main";
import {
  paperValueToInches,
  stationeryNumbers,
} from "../../../data/stationery";
import { openStationery } from "../../MainFrame/functions/stationery/openStationery";

export default function StationeryBox() {
  const { t } = useTranslation();
  // the list shows the page size in inches, the server sends it in pixels
  const pageSizeToInches = (row: stdObject) =>
    stationeryNumbers.reduce(
      (acc: stdObject, code: string) => ({
        ...acc,
        [code]: `${paperValueToInches(row[code])} ${t("p.inches")}`,
      }),
      { ...row },
    );
  const { type, searchValues, setSearchValues, section, closeMsg } =
    useStructureContext();
  const [stationeryList, setStationeryList] = useState<stdObject>({
    type: "PED",
    list: [],
  });
  const {
    setMsg,
    setStaValues,
    setStationeryModal,
    customUpdate,
    logoutAction,
  } = useMainContext();

  const callStationeryInfo = async (data?: stdObject, index?: number) => {
    const type = data ? false : searchValues[section.id].SECTSTA.value;

    setMsg("loading");
    const payloadStationeryInfo: stdObject = { type };
    if (data) {
      payloadStationeryInfo.code = data.CODDOC;
    }
    console.log("payloadStationeryInfo", payloadStationeryInfo);
    const responseStationeryInfo: stdObject = await sendData({
      endPoint: "callStationery",
      payload: payloadStationeryInfo,
      logoutAction,
    });
    console.log("responseStationeryInfo", responseStationeryInfo);
    if (responseStationeryInfo.success && responseStationeryInfo.status) {
      if (responseStationeryInfo.data) {
        openStationery(
          {
            area: responseStationeryInfo.area,
            data: responseStationeryInfo.data,
            parts: responseStationeryInfo.parts,
            doc: responseStationeryInfo.doc,
            rows: responseStationeryInfo.rows,
            person: responseStationeryInfo.person,
            payments: responseStationeryInfo.payments,
            prices: responseStationeryInfo.prices,
            index,
          },
          { setStaValues, setStationeryModal, setMsg, closeMsg, logoutAction },
        );
      } else {
        setStationeryList({
          type,
          list: responseStationeryInfo.list.map(pageSizeToInches),
        });
      }
    }
    closeMsg();
  };

  useEffect(() => {
    if (emptys.includes(searchValues[section.id]?.SECTSTA?.value)) {
      const tempSearch = searchValues;
      tempSearch[section.id].SECTSTA.value = stationeryList.type;
      setSearchValues(tempSearch);
      return;
    }
  }, []);

  useEffect(() => {
    if (!emptys.includes(searchValues[section.id]?.SECTSTA?.value)) {
      callStationeryInfo();
    }
  }, [searchValues[section.id]?.SECTSTA?.value]);

  useEffect(() => {
    if (
      "stationeryInfo" in customUpdate.current &&
      typeof customUpdate.current.stationeryInfo === "number"
    ) {
      console.log("customUpdate.current", customUpdate.current);
      let tempStationery = stationeryList;
      if ("info" in customUpdate.current) {
        const info = pageSizeToInches(customUpdate.current.info);
        if (customUpdate.current.stationeryInfo === -1) {
          tempStationery.list.push(info);
        } else {
          tempStationery.list[customUpdate.current.stationeryInfo] = info;
        }
      } else {
        tempStationery.list.splice(customUpdate.current.stationeryInfo, 1);
      }
      setStationeryList({ ...tempStationery });
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  return "SECTSTA" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={
          stationeryList.type !== "SEV"
            ? areasTitles.DOC.filter((e: stdObject) => e.code !== "ADSDOC").map(
                (e: stdObject) => {
                  return e;
                },
              )
            : areasTitles.DOC.map((e: stdObject) => {
                return e;
              })
        }
        data={stationeryList.list}
        onDoubleClick={callStationeryInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
